import type { Infer } from 'superstruct';
import {
	array,
	assign,
	enums,
	literal,
	nullable,
	number,
	object,
	omit,
	optional,
	partial,
	pick,
	union,
} from 'superstruct';

import {
	UploadGMBTemplateJobReport,
	ViewGMBTemplateDto,
} from '@adflow/shared/data-google-my-business';
import { ViewMediaDto } from '@adflow/shared/data-media';
import { stringDate } from '@adflow/shared/util-superstruct';
import { ViewUserDto } from '@adflow/shared/util-users';

import { historyArrayItem } from '../history-array-item';
import type { HistoryEntityType } from '../history-types';

import { HistoryGMBLocationDto } from './history-gmb-location.dto';

export const HistoryGMBTemplateDto = assign(
	partial(omit(ViewGMBTemplateDto, ['updatedAt'])),
	partial(
		object({
			locations: array(historyArrayItem(HistoryGMBLocationDto)),
			image: pick(ViewMediaDto, ['id', 'name', 'url', 'thumbnailUrl']),
		})
	)
);
export type HistoryGMBTemplateDto = Infer<typeof HistoryGMBTemplateDto>;

const ViewHistoryGMBTemplateBaseDto = object({
	id: number(),
	entityId: number(),
	user: pick(ViewUserDto, ['id', 'name', 'email']),
	userId: number(),
	createdAt: stringDate(),
	origin: optional(enums(['USER', 'MAGENTO'])),
});

export const ViewHistoryGMBTemplateUploadDto = assign(
	ViewHistoryGMBTemplateBaseDto,
	object({
		entityType: literal('GMBTemplate' satisfies HistoryEntityType),
		action: literal('UPLOAD'),
		oldData: optional(nullable(literal(null))),
		newData: UploadGMBTemplateJobReport,
	})
);

const ViewHistoryGMBTemplateOtherDto = assign(
	ViewHistoryGMBTemplateBaseDto,
	object({
		entityType: literal('GMBTemplate' satisfies HistoryEntityType),
		action: enums(['CREATE', 'UPDATE', 'DELETE']),
		oldData: nullable(optional(HistoryGMBTemplateDto)),
		newData: HistoryGMBTemplateDto,
	})
);

export type ViewHistoryGMBTemplateUploadDto = Infer<
	typeof ViewHistoryGMBTemplateUploadDto
>;

export const ViewHistoryGMBTemplateDto = union([
	ViewHistoryGMBTemplateUploadDto,
	ViewHistoryGMBTemplateOtherDto,
]);

export type ViewHistoryGMBTemplateDto = Infer<typeof ViewHistoryGMBTemplateDto>;
